module.exports = __webpack_public_path__ + "img/charging-session-infograph-mobile.2a3147df.png";